import { render } from "./ScanVoucher.vue?vue&type=template&id=a95746e8&scoped=true"
import script from "./ScanVoucher.vue?vue&type=script&lang=js"
export * from "./ScanVoucher.vue?vue&type=script&lang=js"

import "./ScanVoucher.vue?vue&type=style&index=0&id=a95746e8&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a95746e8"]])

export default __exports__